import { Modal, Table, Tag } from "antd";

const LogModal = ({ open, setOpen, logs = [] }) => {
    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Error Message",
            dataIndex: "error_message",
            key: "error_message",
            render: (text) => text ? text : "-"
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                return <Tag color={status === "sent" ? "green" : status === "pending" ? "orange" : "red"}>
                    {status.toUpperCase()}
                </Tag>
            },
        },
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => new Date(date).toLocaleString(),
        },
    ];

    return (
        <Modal
            title="Email Logs"
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
            width={800}
        >
            <Table
                rowKey="id"
                columns={columns}
                dataSource={logs}
                pagination={false}
            />
        </Modal>
    );
};

export default LogModal;
